import { format } from 'date-fns';
export const SCHEDULE_DATE_FORMAT = 'MM/dd/yyyy';
export const SCHEDULE_DATE_INPUT_FORMAT = 'MM/dd/yyyy';
export const SCHEDULE_DATE_ONLY_FORMAT = 'yyyy-MM-dd';
export const parseScheduleDate = value => {
  if (!value || value === '0001-01-01') return null;
  return new Date("".concat(value, "T00:00:00"));
};
export const formatScheduleDate = value => {
  const parsed = parseScheduleDate(value);
  return parsed ? format(parsed, SCHEDULE_DATE_FORMAT) : '';
};
export const formatScheduleTimestampDate = value => {
  if (!value) return '';
  const datePart = value.slice(0, 10);
  if (value.length <= 10) return formatScheduleDate(datePart);
  if (datePart === '0001-01-01') return '';
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? '' : format(parsed, SCHEDULE_DATE_FORMAT);
};

/** Time of day for a full timestamp; empty for a date-only value, which carries no time. */
export const formatScheduleTime = value => {
  if (!value || value.length <= 10) return '';
  const datePart = value.slice(0, 10);
  if (datePart === '0001-01-01') return '';
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? '' : format(parsed, 'h:mm a');
};
export const toScheduleDateOnly = value => format(value, SCHEDULE_DATE_ONLY_FORMAT);
export const formatScheduleDateProse = value => {
  const parsed = parseScheduleDate(value);
  return parsed ? format(parsed, 'MMM d, yyyy') : '';
};
export const formatProseDate = value => {
  const parsed = parseScheduleDate(value);
  if (!parsed) return '';
  return format(parsed, parsed.getFullYear() === new Date().getFullYear() ? 'MMM d' : 'MMM d, yyyy');
};